import { render, staticRenderFns } from "./dp-modal.vue?vue&type=template&id=95aff8cc"
import script from "./dp-modal.vue?vue&type=script&lang=js"
export * from "./dp-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports